module.exports = __webpack_public_path__ + "img/tws1.68aca43e.png";